/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TWebDeleteFavoriteModel = IModel<IWebDeleteFavoriteRequest, TWebDeleteFavoriteResponse>;

export interface IWebDeleteFavoriteRequest {
  /** Тип сделки **/
  dealType: EDealType;
  /** Ид сущности **/
  entityId: number;
  /** Тип сущности **/
  entityType: EEntityType;
  /** Принудительно удалить из папок **/
  forceRemoveFromFolders?: boolean | null;
}

export type TWebDeleteFavoriteResponse = IWebDeleteFavoriteResponse200 | IWebDeleteFavoriteResponse400;

export interface IWebDeleteFavoriteResponse200 extends IModelResponse<IWebDeleteFavoriteResponse> {
  statusCode: 200;
}

export interface IWebDeleteFavoriteResponse400 extends IModelResponse<IWebDeleteFavoriteResponseError> {
  statusCode: 400;
}

export interface IWebDeleteFavoriteResponse {}

export interface IWebDeleteFavoriteResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IWebDeleteFavoriteResponse | IWebDeleteFavoriteResponseError;

export enum EDealType {
  /** Аренда **/
  Rent = 'rent',
  /** Продажа **/
  Sale = 'sale',
}

export enum EEntityType {
  /** Коммерческая **/
  Commercial = 'commercial',
  /** ЖК **/
  Newbuilding = 'newbuilding',
  /** Жилая **/
  Residential = 'residential',
  /** Загородка **/
  Suburban = 'suburban',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IWebDeleteFavoriteResponse): TResponse200;
  400(response: IWebDeleteFavoriteResponseError): TResponse400;
}
